module.exports = __webpack_public_path__ + "img/dd-logo-cjdr-w.2d37e279.png";